import { LinearProgress } from '@material-ui/core';
import DataGrid from 'components/DataGrid/DataGrid';
import { toFA } from 'fns/toFA';
import React, { useMemo } from 'react';
// import { localText } from '../../../../../langs/fa/data-grid';
import { isMobile } from 'react-device-detect';
import { useMainStore } from 'useStores/useMainStore';
import { useOnlineUsersStore } from './useOnlineUsersStore';
import { toEN } from 'fns';
import { formatNumber } from 'fns';
import { rond } from 'fns';
import UserAvatar from 'components/User/UserAvatar';
import { useHistory } from 'react-router-dom';

const List = () => {
  const isLoading = useOnlineUsersStore((state) => state.isLoading);
  const users = useOnlineUsersStore((state) => state.users);
  const changePage = useOnlineUsersStore((state) => state.changePage);
  const page = useOnlineUsersStore((state) => state.page);
  const limit = useMainStore((state) => state.limit);
  const history = useHistory();

  const columns = useMemo(
    () => [
      {
        field: 'row',
        sortable: false,
        headerName: 'ردیف',
        width: 90,
        renderCell: ({ value }) => <div>{toFA(value)}</div>,
      },
      {
        field: 'company',
        sortable: false,
        headerName: 'کاربر',
        flex: 1,
        renderCell: ({ value }) => <div>{!!value ? value : '-'}</div>,
      },
      {
        field: 'fullName',
        sortable: false,
        headerName: 'نام و نام خانوادگی',
        width: 200,
        renderCell: ({ value }) => (
          <div className="d-flex" style={{ gap: 8 }}>
            <UserAvatar
              user={value}
              fullName
              width={30}
              height={30}
              justAvatar
            />
            <div>{`${value?.firstName || ''} ${value?.lastName || ''}`}</div>
          </div>
        ),
      },
      {
        field: 'onlineOrdersCount',
        sortable: false,
        headerName: 'سفارش آنلاین',
        width: 150,
        renderCell: ({ value }) => <div>{!!value ? toFA(value) : '-'}</div>,
      },
      {
        field: 'offlineOrdersCount',
        sortable: false,
        headerName: 'سفارش سنتی',
        width: 150,
        renderCell: ({ value }) => <div>{!!value ? toFA(value) : '-'}</div>,
      },
      {
        field: 'onlineCommissions',
        sortable: false,
        headerName: 'کارمزد آنلاین',
        width: 150,
        renderCell: ({ value }) => (
          <div>{!!value ? toFA(formatNumber(toEN(rond(value)))) : '-'}</div>
        ),
      },
      {
        field: 'offlineCommissions',
        sortable: false,
        headerName: 'کارمزد سنتی',
        width: 150,
        renderCell: ({ value }) => (
          <div>{!!value ? toFA(formatNumber(toEN(rond(value)))) : '-'}</div>
        ),
      },
    ],
    [users]
  );

  const handlePageChange = async (page) => {
    changePage(page);
  };

  function handleSelectUser(data) {
    const userId = users.docs.find((item) => item._id === data?.row?.id);
    history.push(`/protected/admin/reports/onlineUsers/${userId.user._id}`);
  }

  return (
    <div
      style={{
        width: '100%',
        position: 'relative',
        height: isMobile ? 'initial' : 480,
      }}
    >
      {isLoading && <LinearProgress />}
      {users !== null && (
        <DataGrid
          rows={
            users?.docs?.map((user, i) => ({
              id: user._id,
              row: (page - 1) * limit + i + 1,
              company: user.user?.company,
              fullName: user.user,
              onlineOrdersCount: user.online && user.count,
              offlineOrdersCount: !user.online && user.count,
              onlineCommissions: user.online && user.amount,
              offlineCommissions: !user.online && user.amount,
            })) || []
          }
          columns={columns}
          // localeText={localText}
          onPageChange={handlePageChange}
          paginationMode="server"
          pageSize={limit}
          pageNumber={page * 1}
          rowCount={users?.totalDocs || 0}
          disableMultipleSelection
          onCellClick={handleSelectUser}
          density="compact"
          totalPages={users?.totalPages}
          defaultPage={users?.page}
          footerPagination={true}
          // onSelectionChange={handleSelectUser}
        />
      )}
    </div>
  );
};

export default List;
